import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';

const routes: Routes = [

  {
    path: '',
    redirectTo: environment.PAGES.qr_ingreso.url,
    pathMatch: 'full',
  },
  {
    path: '/qr',
    redirectTo: environment.PAGES.qr_ingreso.url,
    pathMatch: 'full',
  },
  {
    path: environment.PAGES.qr_ingreso.url,
    loadChildren: () =>
      import('./project/pages/qr-ingreso/qr-ingreso.module').then(
        (m) => m.QrIngresoPageModule
      ),
  },
  {
    path: 'qr',
    loadChildren: () =>
      import('./project/pages/qr-ingreso/qr-ingreso.module').then(
        (m) => m.QrIngresoPageModule
      ),
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
